/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import formatError from "../../services/FormatError";
import { getStatusBadge } from "./Business";
import AddContractPopup from "./AddContract";
import {
  fetchBusinessDetails,
  getIncomeStatementFile,
} from "../../services/BusinessService";
import { Alert, Button, Modal, ProgressBar, Stack } from "react-bootstrap";
import { Icon } from "@iconify/react/dist/iconify.js";
import Rating from "../components/UIComponents/Rating";
import avatar from "../../images/user.png";
import { useTranslation } from "react-i18next";
import {
  assignedRepToBusinessService,
  assignProfessional,
  assignRepresentativeToBusiness,
  cancelRepRequestService,
  listAssignedProfessional,
  listProfessional,
  reAssignRepresentativeToBusiness,
  requestForRepresentative,
  searchRepresentative,
} from "../../services/RepresentativeService";
import swal from "sweetalert";
import Loader from "../components/Loader";
import "react-18-image-lightbox/style.css";
import DocumentViewer from "../components/UIComponents/DocumentViewer";
import { Editor } from "@tinymce/tinymce-react";
import { createNote } from "../../services/NoteService";
import ImageLoader from "../components/UIComponents/ImageLoader";
import useScript from "../../hooks/useTinyScript";
import { useDispatch, useSelector } from "react-redux";
import { minutesActions, minutesThunks } from "../../store/minutes/actions";
import minutes from "../../store/minutes";
import { fetchDealProgress } from "../../services/DealProgressTrackerService";
import DealProgressBar from "../components/dealProgress/DealBar";
import BusinessDetailsInfo from "./BusinessDetailsInfo";
import CalendarDashboard from "../components/Calendar/CalendarDashboard";
import BusinessEvaluator from "./Summary";
import VoiceNote from "../components/VoiceNotes/VoiceNote";
import { id } from "date-fns/locale";
import { set } from "date-fns";
import config from "../../config";
import medical_clinic from "../../images/business_domain_logo/medical_clinic.jpg";
import vision_care from "../../images/business_domain_logo/vision.jpg";
import podiatry from "../../images/business_domain_logo/podiatre.jpg";
import medical_equipment from "../../images/business_domain_logo/medical_material.jpg";
import psychology from "../../images/business_domain_logo/psychologie.jpg";

const domainLogo = {
  medical_clinic: medical_clinic,
  vision_care: vision_care,
  podiatry: podiatry,
  medical_equipment: medical_equipment,
  psychology: psychology,
};
// Sample data for demonstration
const sampleStages = [
  {
    id: 1,
    title: "Profile Submitted",
    icon: "check",
    date: "2025-06-07T10:00:00Z",
    status: "completed",
  },
  {
    id: 2,
    title: "Assigned to Partner",
    icon: "user",
    partner: { name: "Jane Doe", imageUrl: "/avatars/jane.jpg" },
    status: "completed",
  },
  {
    id: 3,
    title: "In Evaluation",
    icon: "clock",
    since: "2 days",
    status: "current",
  },
  {
    id: 4,
    title: "Buyer Match",
    icon: "file-text",
    pendingDocs: 2,
    status: "upcoming",
  },
  {
    id: 5,
    title: "Completed",
    icon: "lock",
    status: "upcoming",
  },
];
function ProgressItem({ star, total, name }) {
  return (
    <Stack direction="horizontal" gap={3} className="mb-2 align-items-center">
      <div>
        {name}{" "}
        <Icon
          icon="iconamoon:star-fill"
          className="w-4 h-4 mr-1 ms-1"
          color="#FFBF03"
        />
      </div>
      <ProgressBar
        now={(star / total) * 100}
        className="flex-grow-1"
        style={{ marginRight: "10px", backgroundColor: "#e9ecef" }}
      />
      <div style={{ minWidth: "64px", textAlign: "right", color: "#6c757d" }}>
        {/* {fShortenNumber(star)} */}
        {star}
      </div>
    </Stack>
  );
}

function ReviewItem({ ...props }) {
  const { review, note, repr, isLoading } = props;
  console.log("review: ", review);

  return (
    <div className="pt-2">
      <div className="d-flex flex-column flex-sm-row align-items-start p-2">
        <div className="me-3 d-flex align-items-center mb-2 mb-sm-0 text-center">
          <img
            src={review?.user?.cover?.url ?? avatar}
            alt={review?.user?.fullName ?? ""}
            className="rounded-circle"
            style={{ width: "64px", height: "64px" }}
          />
        </div>

        <div className="w-100">
          <div className="float-end">
            <small className="text-secondary float-end">11-11-2024</small>
          </div>
          {/* <h6 className="text-capitalize">{review?.user?.fullName ?? ""}</h6> */}
          <h6 className="text-capitalize">{repr} (Representative) </h6>
          <p className="mb-1 mt-1 fw-normal">{review ?? ""}</p>
          <div className="d-flex">
            <Rating rating={note} />
          </div>
        </div>
      </div>
      {/* <div className="p-3">
				<div className="row">
					{!isLoading &&
						review?.images?.map((image) => (
							<div className="col-6 col-md-3 col-lg-2" key={Math.random()}>
								<div className="position-relative" style={{ height: "100px", borderRadius: "8px" }}>
									<img
										src={image}
										alt={review?.name + "'s review"}
										layout="fill"
										objectFit="cover"
										style={{ borderRadius: "8px" }}
									/>
								</div>
							</div>
						))}
				</div>
			</div> */}
      <hr />
    </div>
  );
}

function BusinessDetails() {
  const { t } = useTranslation();
  const ctxObj = JSON.parse(sessionStorage.getItem("userDetails"))?.result;
  const role = JSON.parse(sessionStorage.getItem("userDetails"))?.result;
  const navigate = useNavigate();

  const params = useParams();

  const [businessDetails, setBusinessDetails] = useState({});

  const [createContract, setCreateContract] = useState({
    cond: false,
    data: {},
  });

  const [listProfessionals, setListProfessionals] = useState([]);
  const [AssignedProfessionalList, setAssignedProfessionalList] = useState([]);

  const [sugg, setSugg] = useState(false);
  const [showAssignModal, setShowAssignModal] = useState(false);
  const [professionalAssignModal, setProfessinalAssignModal] = useState(false);
  const [representativeList, setRepresentativeList] = useState([]);
  const [selectedRepresentativeId, setSelectedRepresentativeId] = useState("");
  const [loading, setLoading] = useState(true);
  const [allFiles, setAllFiles] = useState([]);
  const [showImageModal, setShowImageModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");
  const [showVideoModal, setShowVideoModal] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState("");
  const [showDocModal, setShowDocModal] = useState(false);
  const [selectedDoc, setSelectedDoc] = useState("");
  const [showNoteModal, setShowNoteModal] = useState(false);
  const [showVoiceNoteModal, setShowVoiceNoteModal] = useState(false);
  const [noteContent, setNoteContent] = useState("");
  const [noteTitle, setNoteTitle] = useState("");
  //deal Ptorgess
  const [progress, setProgress] = useState([]);
  const [progressLoading, setProgressLoading] = useState(true);
  // minutes selectors
  const businessMinutes = useSelector((state) => state.minutes.minutes);
  const minute = useSelector((state) => state.minutes.minute);
  // console.log("minute: ", minute);
  const isLoading = useSelector((state) => state.minutes.loading);
  // console.log("businessMinutes: ", businessMinutes);
  const dispatch = useDispatch();
  useEffect(() => {
    getBusinessDetails();
    role?.role?.id === 2 && getRepresentative();
    requestedRepToBusiness();
    dispatch(minutesThunks.fetchBusinessMinutes(params?.businessId));
  }, []);

  useEffect(() => {
    if (ctxObj?.role?.id === 2 || ctxObj?.role?.id === 1) {
      listProfessional(params?.businessId).then((res) => {
        setListProfessionals(res?.data?.result ?? []);
      });
    }
    if (ctxObj?.role?.id === 2 || ctxObj?.role?.id === 1) {
      listAssignedProfessional(params?.businessId).then((res) => {
        setAssignedProfessionalList(res?.data?.result ?? []);
      });
    }
    if (
      businessDetails?.status === "Unpublished" &&
      !businessDetails?.has_income_statement
    ) {
      setSugg(true);
    } else {
      setSugg(false);
    }
    if (!businessDetails?.has_income_statement) {
      setProgressLoading(false);
      return;
    } else {
      try {
        setProgressLoading(true);
        fetchDealProgress(params?.businessId).then((res) => {
          setProgress(res.data?.result);
          setProgressLoading(false);
        });
      } catch (error) {
        formatError(error.response?.data?.error);
        setProgressLoading(false);
      }
    }
  }, [businessDetails]);

  const [dealTracker, setDealTracker] = useState(false);
  const getBusinessDetails = () => {
    fetchBusinessDetails(params?.businessId)
      .then((res) => {
        const data = res.data?.result;
        let tempAllFiles = [];
        if (data?.documents !== null) {
          data?.documents?.map((item) => {
            tempAllFiles.push({
              type: "document",
              url: `${config?.appUrl}/file/view?key=${item?.key}&type=DOCUMENT`,
            });
            return {};
          });
        }
        if (data?.audios !== null) {
          data?.audios?.map((item) => {
            tempAllFiles.push({
              id: item?.id,
              type: "audio",
              url: `${config?.appUrl}/file/view?key=${item?.key}&type=AUDIO`,
              description: item?.description,
              createdat: item?.createdat,
            });
            return {};
          });
        }
        if (data?.images !== null) {
          data?.images?.map((item) => {
            tempAllFiles.push({
              type: "image",
              url: `${config?.appUrl}file/view?key=${item?.key}&type=IMAGE`,
            });
            return {};
          });
        }
        if (data?.videos !== null) {
          data?.videos?.map((item) => {
            tempAllFiles.push({
              type: "video",
              url: `${config?.appUrl}/file/view?key=${item?.key}&type=VIDEO`,
            });
            return {};
          });
        }
        setAllFiles(tempAllFiles);
        setBusinessDetails(res.data?.result ?? {});
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        formatError(error.response?.data?.error);
      });
  };

  const getRepresentative = (value) => {
    searchRepresentative(value)
      .then((res) => {
        if (res?.data?.result !== null) {
          console.log("from get", res?.data?.result);
          setRepresentativeList(res?.data?.result);
        } else {
          setRepresentativeList([]);
        }
      })
      .catch((error) => {
        formatError(error.response?.data?.error);
      });
  };

  const onBack = () => {
    navigate("/business");
  };

  const onCreateContract = () => {
    setCreateContract({
      cond: true,
      data: businessDetails,
    });
  };
  // Permissions
  const canSeeBusinesssDetails =
    role?.role?.id === 1 ||
    role?.role?.id === 2 ||
    (role?.role?.id === 3 && role?.loggedinprofiletype === "sellerprofile");
  const onHideModal = () => {
    setCreateContract({
      cond: false,
      data: {},
    });

    getBusinessDetails();
  };

  const onDownloadIncomeStatement = () => {
    getIncomeStatementFile(params?.businessId)
      .then((res) => {
        const link = document.createElement("a");
        link.href = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${res.data?.result?.file}`;
        link.download = `${businessDetails?.name} Income Statement.xlsx`;
        link.click();
      })
      .catch((error) => {
        formatError(error.response?.data?.error);
      });
  };

  const businessReAsignHandler = (repId) => {
    setLoading(true);
    try {
      reAssignRepresentativeToBusiness(Number(params?.businessId), repId)
        .then((res) => {
          getBusinessDetails();
          swal("Success", t("assignmentRemovedSuccessfully"), "success");
          setShowAssignModal(false);
          setProfessinalAssignModal(false);
          setLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setLoading(false);
          swal("Oops", t("hsomethingWrong"), "error", {
            button: t("htry"),
          });
        });
    } catch (error) {
      formatError(error.response?.data?.error);
      setLoading(false);
    }
  };
  const businessAsignHandler = () => {
    setLoading(true);
    try {
      assignRepresentativeToBusiness(
        Number(params?.businessId),
        selectedRepresentativeId
      )
        .then((res) => {
          getBusinessDetails();
          swal("Success", t("hsuccessRepresentative"), "success");
          setRepresentativeList([]);
          setShowAssignModal(false);
          setProfessinalAssignModal(false);
          setLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setLoading(false);
          swal("Oops", t("hsomethingWrong"), "error", {
            button: t("htry"),
          });
        });
    } catch (error) {
      formatError(error.response?.data?.error);
      setLoading(false);
    }
  };

  const representativeSearchHandler = (e) => {
    getRepresentative(e.target.value);
  };

  const assignToProfessional = async (selectedProfessionalId, profession) => {
    setLoading(true);
    try {
      assignProfessional(
        Number(params?.businessId),
        selectedProfessionalId,
        profession
      )
        .then((res) => {
          getBusinessDetails();
          swal("Success", t("hsuccessProfessional"), "success");
          setShowAssignModal(false);
          setProfessinalAssignModal(false);
          setLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setLoading(false);
          swal("Oops", t("hsomethingWrong"), "error", {
            button: t("htry"),
          });
        });
    } catch (error) {
      formatError(error.response?.data?.error);
      setLoading(false);
    }
  };
  const [requestedRep, setRequestedRep] = useState({});
  const requestedRepToBusiness = async () => {
    setLoading(true);
    try {
      assignedRepToBusinessService(Number(params?.businessId))
        .then((res) => {
          setRequestedRep(res?.data?.result);
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      formatError(error.response?.data?.error);
    }
  };
  const cancelRepRequest = async (selectedRepId) => {
    setLoading(true);
    try {
      cancelRepRequestService(Number(params?.businessId), selectedRepId)
        .then((res) => {
          swal("Success", t("cancelRequestSuccessfully"), "success");

          setLoading(false);
          setRequestedRep({});
        })
        .catch((error) => {
          console.log(error);
          setLoading(false);
          swal("Oops", t("hsomethingWrong"), "error", {
            button: t("htry"),
          });
        });
    } catch (error) {
      formatError(error.response?.data?.error);
      setLoading(false);
    }
  };
  const requestRepresentative = async (selectedRepId) => {
    setLoading(true);
    try {
      requestForRepresentative(Number(params?.businessId), selectedRepId)
        .then((res) => {
          getBusinessDetails();
          swal("Success", t("representativeRequestSuccess"), "success");
          requestedRepToBusiness();
          setProfessinalAssignModal(false);
          setLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setLoading(false);
          swal("Oops", t("hsomethingWrong"), "error", {
            button: t("htry"),
          });
        });
    } catch (error) {
      formatError(error.response?.data?.error);
      setLoading(false);
    }
  };

  const submitNoteHandler = () => {
    setLoading(true);
    const payload = {
      authorizedparties:
        ctxObj?.role?.id === 2
          ? ["BUSINESS_OWNERS", "REPRESENTATIVE", "PROFESSIONAL"]
          : ["BUSINESS_OWNERS", "PROFESSIONAL"],
      businessid: Number(params?.businessId),
      content: noteContent,
      title: noteTitle,
    };
    createNote(payload)
      .then((res) => {
        setLoading(false);
        setNoteContent("");
        setNoteTitle("");
        setShowNoteModal(false);
        swal("Success", t("hminutecreated"), "success");
      })
      .catch((error) => {
        formatError(error.response?.data?.error);
      });
  };
  const isScriptLoaded = useScript("/tinymce/tinymce.min.js");
  const [showMinutesModal, setShowMinutesModal] = useState(false);
  const [summaryModal, setSummaryModal] = useState(false);

  // Inside BusinessDetails component (top-level)
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 5;

  const [searchProfessional, setSearchProfessional] = useState("");
  const [filteredProfessionals, setFilteredProfessionals] = useState([]);

  useEffect(() => {
    const filtered = listProfessionals?.filter((professional) => {
      return searchProfessional === ""
        ? listProfessionals
        : professional?.name?.toLowerCase().includes(searchProfessional) ||
            professional?.email?.toLowerCase().includes(searchProfessional);
    });
    setFilteredProfessionals(filtered);
  }, [searchProfessional, listProfessionals]);

  // Pagination logic
  const totalPages =
    Math.ceil(filteredProfessionals?.length / rowsPerPage) || 1;
  const indexOfLast = currentPage * rowsPerPage;
  const indexOfFirst = indexOfLast - rowsPerPage;
  const currentRows = filteredProfessionals?.slice(indexOfFirst, indexOfLast);
  // Represebtative
  const [currentPageRep, setCurrentPageRep] = useState(1);
  const rowsPerPageRep = 5;

  // Pagination logic for Representative table
  const totalPagesRep =
    Math.ceil(representativeList?.length / rowsPerPageRep) || 1;
  const indexOfLastRep = currentPageRep * rowsPerPageRep;
  const indexOfFirstRep = indexOfLastRep - rowsPerPageRep;
  const currentRowsRep = representativeList?.slice(
    indexOfFirstRep,
    indexOfLastRep
  );
  return (
    <>
      {loading && <Loader forProcess={true} />}
      {Object.keys(businessDetails)?.length > 0 ? (
        <div className="col-lg-12">
          <div className="card project-card">
            <div className="card-header d-sm-flex align-items-center justify-content-between d-flex">
              <div className="d-flex align-items-center mb-sm-0">
                <span
                  style={{ fontSize: "18px", cursor: "pointer" }}
                  className="d-flex justify-content-start align-items-center me-3"
                  onClick={onBack}
                >
                  <i className="fa fa-arrow-left"></i>
                </span>
                <h4 className="card-title mb-0">{t("businessDetailsTitle")}</h4>
              </div>

              <div className="d-flex align-items-center gap-3">
                {ctxObj?.role?.id === 2 && (
                  <div>
                    {businessDetails?.assigned_representative_id ? (
                      <div
                        className="bg-primary text-white rounded"
                        onClick={() => {
                          setShowAssignModal(true);
                        }}
                      >
                        <p className="px-4 py-2 d-flex fw-semibold mb-0">
                          {t("assignedTo")} :{" "}
                          {businessDetails?.representative_name}
                        </p>
                      </div>
                    ) : (
                      <button
                        className="btn btn-primary"
                        onClick={() => {
                          setShowAssignModal(true);
                        }}
                      >
                        {t("businessDetailsAssignButton")}
                      </button>
                    )}
                  </div>
                )}
                {ctxObj?.role?.id === 2 && (
                  <div>
                    {AssignedProfessionalList?.length > 0 ? (
                      <div
                        className="bg-success text-white rounded "
                        onClick={() => setProfessinalAssignModal(true)}
                      >
                        <p className="px-4 py-2 d-flex align-items-center cursor-pointer gap-2 fw-semibold mb-0">
                          <i class="fa fa-check-circle" aria-hidden="true"></i>{" "}
                          {t("professionalAssigned")}
                        </p>
                      </div>
                    ) : (
                      <button
                        className="btn btn-primary"
                        onClick={() => setProfessinalAssignModal(true)}
                      >
                        {t("businessAssignToProfessionalButton")}
                      </button>
                    )}
                  </div>
                )}

                {role?.role?.id !== 3 &&
                  role?.role?.id !== 4 &&
                  role?.role?.id !== 5 && (
                    <div>
                      <button
                        className="btn btn-info"
                        onClick={() => setSummaryModal(true)}
                      >
                        {t("businessEvaluator")}
                      </button>
                    </div>
                  )}
              </div>
            </div>
            {summaryModal && (
              <BusinessEvaluator setShowModal={setSummaryModal} />
            )}
            <div></div>
            {sugg && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  background: "#eb8153",
                  color: "#fff",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexGrow: "1",
                  }}
                >
                  {t("businessDetailspublishWarning")}
                </div>
                <div style={{ flexShrink: "0", marginRight: "8px" }}>
                  <i className="fa fa-close" onClick={() => setSugg(false)}></i>
                </div>
              </div>
            )}
            <div className="card-body">
              <div className="business-header d-flex justify-content-between">
                <div className="d-flex align-items-start">
                  {canSeeBusinesssDetails && (
                    <div className="me-3">
                      {businessDetails?.icon ? (
                        <img
                          src={`${config?.appUrl}file/view?key=${businessDetails?.icon}&type=IMAGE`}
                          className="business-logo"
                          alt="Business Logo"
                        />
                      ) : (
                        <div className="me-3">
                          {domainLogo[businessDetails?.domain] ? (
                            <img
                              src={`${domainLogo[businessDetails?.domain]}`}
                              className="business-logo"
                              alt="Business Logo"
                            />
                          ) : (
                            <div className="business-logo d-flex justify-content-center align-items-center">
                              <i
                                className="fa fa-briefcase text-secondary"
                                style={{ fontSize: "60px" }}
                              ></i>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  )}
                  {!canSeeBusinesssDetails && (
                    <div className="me-3">
                      {domainLogo[businessDetails?.domain] ? (
                        <img
                          src={`${domainLogo[businessDetails?.domain]}`}
                          className="business-logo"
                          alt="Business Logo"
                        />
                      ) : (
                        <div className="business-logo d-flex justify-content-center align-items-center">
                          <i
                            className="fa fa-briefcase text-secondary"
                            style={{ fontSize: "60px" }}
                          ></i>
                        </div>
                      )}
                    </div>
                  )}
                  {canSeeBusinesssDetails && (
                    <div className="flex-grow-1 w-50">
                      <h1 className="business-title">
                        {businessDetails?.name}
                        <span className="fst-italic">
                          (
                          {`${businessDetails?.business_number}-${businessDetails?.id}`}
                          )
                        </span>{" "}
                      </h1>
                      {businessDetails?.website && (
                        <div className="business-subtitle">
                          🌐 {businessDetails?.website}
                        </div>
                      )}
                      <div className="business-subtitle">
                        🏢 {t(businessDetails?.domain)} •{" "}
                        {businessDetails?.type}
                      </div>
                    </div>
                  )}
                  {!canSeeBusinesssDetails && (
                    <div className="flex-grow-1 w-50">
                      <h1 className="business-title">
                        {t("a")} {t(businessDetails?.domain)}
                        <span className="fst-italic">
                          (
                          {`${businessDetails?.business_number}-${businessDetails?.id}`}
                          )
                        </span>{" "}
                        {t("forsalein")}{" "}
                        <span className="text-secondary">
                          {businessDetails?.region}
                        </span>
                      </h1>

                      <div className="business-subtitle">
                        🏢 {t(businessDetails?.domain)} •{" "}
                        {businessDetails?.type}
                      </div>
                    </div>
                  )}
                </div>
                <div className=" d-flex flex-wrap align-items-start justify-content-center gap-2 w-50">
                  {ctxObj?.loggedinprofiletype === "sellerprofile" &&
                    (businessDetails?.status === "Unpublished" ||
                      businessDetails?.status === "available") && (
                      <div className="me-2">
                        <button
                          type="button"
                          style={{
                            height: "40px",
                            whiteSpace: "nowrap",
                            paddingTop: "0px",
                            paddingBottom: "0px",
                          }}
                          className="btn btn-primary"
                          onClick={() =>
                            navigate("/upload-files", {
                              state: {
                                businessId: params?.businessId,
                                viewMode: businessDetails?.has_income_statement,
                              },
                            })
                          }
                        >
                          <i className="fa fa-upload me-2"></i>
                          {t("uploadBusinessFileButton")}
                        </button>
                      </div>
                    )}
                  {ctxObj?.loggedinprofiletype === "sellerprofile" &&
                    (businessDetails?.status === "Unpublished" ||
                      businessDetails?.status === "available") && (
                      <div className="me-2">
                        <button
                          type="button"
                          style={{ height: "40px", whiteSpace: "nowrap" }}
                          className="btn btn-primary btn-sm"
                          onClick={() =>
                            navigate("/incomeStatement", {
                              state: {
                                businessId: params?.businessId,
                                viewMode: businessDetails?.has_income_statement,
                              },
                            })
                          }
                        >
                          <i className="fa fa-upload me-2"></i>
                          {businessDetails?.has_income_statement
                            ? "View"
                            : "Upload"}{" "}
                          {t("businessDetailsIncomeStatementButton")}
                        </button>
                      </div>
                    )}
                  {businessDetails?.has_income_statement &&
                    (role?.role?.id === 1 ||
                      role?.role?.id === 2 ||
                      role?.role?.id === 4 ||
                      role?.role?.id === 5 ||
                      (role?.role?.id === 3 &&
                        ctxObj?.loggedinprofiletype === "sellerprofile")) && (
                      <div className="me-2">
                        <button
                          type="button"
                          style={{
                            height: "40px",
                            whiteSpace: "nowrap",
                            fontSize: "12px",
                          }}
                          className="btn btn-primary btn-sm"
                          onClick={onDownloadIncomeStatement}
                        >
                          <i className="fa fa-upload me-2"></i>
                          {t("businessDetailsIncomeStatementDownloadButton")}
                        </button>
                      </div>
                    )}

                  {ctxObj?.loggedinprofiletype === "sellerprofile" && (
                    // businessDetails?.status === "pending" && (
                    <div className="me-2">
                      <button
                        type="button"
                        style={{
                          height: "40px",
                          whiteSpace: "nowrap",
                          fontSize: "12px",
                        }}
                        className="btn btn-primary btn-sm"
                        onClick={onCreateContract}
                      >
                        {t("businessDetailsCreateContractButton")}
                      </button>
                    </div>
                  )}
                  {(ctxObj?.loggedinprofiletype === "sellerprofile" ||
                    ctxObj?.loggedinprofiletype === "buyerprofile") &&
                    businessDetails?.status === "pending" && (
                      <div className="">
                        <button
                          type="button"
                          style={{ height: "40px", whiteSpace: "nowrap" }}
                          className="btn btn-primary btn-sm"
                          onClick={() =>
                            navigate("/contracts", {
                              state: params?.businessId,
                            })
                          }
                        >
                          {t("businessDetailsContractsButton")}
                        </button>
                      </div>
                    )}
                  {ctxObj?.loggedinprofiletype === "sellerprofile" && (
                    <div className="">
                      <button
                        type="button"
                        style={{
                          height: "40px",
                          whiteSpace: "nowrap",
                          fontSize: "12px",
                        }}
                        className="btn btn-primary btn-sm"
                        onClick={() =>
                          navigate("/offers", { state: params?.businessId })
                        }
                      >
                        {t("businessDetailsOffersButton")}
                      </button>
                    </div>
                  )}
                  {(ctxObj?.role?.id === 2 || ctxObj?.role?.id === 4) && (
                    <div className="">
                      <button
                        type="button"
                        style={{
                          height: "40px",
                          whiteSpace: "nowrap",
                          fontSize: "12px",
                        }}
                        className="btn btn-primary btn-sm"
                        onClick={() => {
                          setShowNoteModal(true);
                        }}
                      >
                        {t("addAMinutes")}
                      </button>
                    </div>
                  )}
                  {(ctxObj?.role?.id === 2 ||
                    ctxObj?.loggedinprofiletype === "sellerprofile") && (
                    <div className="me-2">
                      <button
                        type="button"
                        style={{ height: "40px", whiteSpace: "nowrap" }}
                        className="btn btn-primary btn-sm"
                        onClick={() => {
                          setShowVoiceNoteModal(true);
                        }}
                      >
                        <i class="fa fa-microphone" aria-hidden="true"></i>
                      </button>
                    </div>
                  )}
                  {((businessDetails?.has_income_statement &&
                    ctxObj?.role?.id === 2) ||
                    ctxObj?.role?.id === 4) && (
                    <div className="me-2">
                      {/* <button
                        type="button"
                        style={{
                          height: "32px",
                          paddingTop: "0px",
                          paddingBottom: "0px",
                        }}
                        className="btn btn-primary me-3"
                        onClick={() => {
                          setDealTracker(true);
                        }}
                      >
                        Deal Progress Tracker
                      </button> */}
                    </div>
                  )}
                  <span
                    className={`badge d-sm-inline-block d-none ${getStatusBadge(
                      businessDetails?.status
                    )}`}
                  >
                    {t(businessDetails?.status)}
                  </span>
                  {/* {role?.role?.id === 2 && (
                    <a
                      href={`https://calendly.com/app/scheduling/meeting_types/user/me`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Icon
                        icon="mdi:calendar"
                        fontSize={30}
                        style={{ cursor: "pointer" }}
                        className="ms-2 text-primary"
                      />
                    </a>
                  )} */}
                </div>
              </div>
              {businessDetails?.description && (
                <div className="business-discription">
                  <h6>{t("descriptionInput")}</h6>
                  <p>{businessDetails?.description}</p>
                </div>
              )}

              {businessDetails?.status !== "Unpublished" && (
                <DealProgressBar
                  stages={progress}
                  businessDetails={businessDetails}
                />
              )}
              <BusinessDetailsInfo businessDetails={businessDetails} />

              {allFiles?.filter((f) => f.type === "image")?.length !== 0 && (
                <div>
                  <div
                    className="d-flex my-2 p-2  border-bx"
                    style={{
                      overflowX:
                        allFiles?.filter((f) => f.type === "image")?.length > 6
                          ? "scroll"
                          : "hidden",
                    }}
                  >
                    {allFiles
                      ?.filter((f) => f.type === "image")
                      ?.map((item) => {
                        return (
                          <div
                            style={{
                              width: "200px",
                              height: "150px",
                              marginRight: "10px",
                              borderRadius: "5px",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              setSelectedImage(item?.url);
                              setShowImageModal(true);
                            }}
                          >
                            <ImageLoader
                              src={item?.url}
                              alt="image"
                              width="200px"
                              height="150px"
                            />
                          </div>
                          // <img
                          // 	src={item?.url}
                          // 	alt=""
                          // 	loading="lazy"
                          // 	style={{
                          // 		width: "200px",
                          // 		height: "150px",
                          // 		marginRight: "10px",
                          // 		borderRadius: "5px",
                          // 		cursor: "pointer",
                          // 	}}
                          // onClick={() => {
                          // 	setSelectedImage(item?.url);
                          // 	setShowImageModal(true);
                          // }}
                          // />
                        );
                      })}
                  </div>
                </div>
              )}

              {allFiles?.filter((f) => f.type === "video")?.length !== 0 && (
                <div className="my-4">
                  <h4>{t("videos")}</h4>
                  <div
                    className="d-flex my-2 p-2  border-bx"
                    style={{
                      overflowX:
                        allFiles?.filter((f) => f.type === "video")?.length > 6
                          ? "scroll"
                          : "hidden",
                    }}
                  >
                    {allFiles
                      ?.filter((f) => f.type === "video")
                      ?.map((item) => {
                        return (
                          <video
                            src={item?.url}
                            alt=""
                            // loading="lazy"
                            style={{
                              width: "200px",
                              height: "150px",
                              marginRight: "10px",
                              borderRadius: "5px",
                              cursor: "pointer",
                            }}
                            controls
                            onClick={() => {
                              setSelectedVideo(item?.url);
                              setShowVideoModal(true);
                            }}
                          />
                        );
                      })}
                  </div>
                </div>
              )}

              {allFiles?.filter((f) => f.type === "document")?.length !== 0 && (
                <div className="my-4">
                  <h4>{t("hsubmitdocument")}</h4>
                  <div
                    className="row my-2 p-2  border-bx"
                    style={{
                      overflowX:
                        allFiles?.filter((f) => f.type === "document")?.length >
                        6
                          ? "scroll"
                          : "hidden",
                    }}
                  >
                    {allFiles
                      ?.filter((f) => f.type === "document")
                      ?.map((item) => {
                        return (
                          <div className="col-4 ">
                            <div
                              className=" d-flex align-items-center"
                              style={{
                                display: "inline-flex",
                                width: "fit-content",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                setSelectedDoc(item?.url);
                                setShowDocModal(true);
                              }}
                            >
                              <Icon
                                icon="vscode-icons:file-type-pdf2"
                                style={{
                                  fontSize: "50px",
                                  marginRight: "10px",
                                }}
                              />
                              <p className="mt-1" style={{ margin: 0 }}>
                                Document 1
                              </p>
                            </div>
                          </div>
                        );
                      })}
                  </div>
                </div>
              )}

              {showImageModal && (
                <Modal
                  className="modal fade "
                  // dialogClassName="modal-50w"
                  size="lg"
                  backdrop="static"
                  show={showImageModal}
                  onHide={() => {
                    setSelectedImage("");
                    setShowImageModal(false);
                  }}
                >
                  <div className="modal-header border-0">
                    <button
                      type="button"
                      className="close btn"
                      onClick={() => {
                        setSelectedImage("");
                        setShowImageModal(false);
                      }}
                    >
                      <span>×</span>
                    </button>
                  </div>
                  <div className="mx-auto my-5">
                    <img
                      src={selectedImage}
                      alt=""
                      // loading={(e) => console.log(e)}
                      style={{
                        width: "600px",
                        cursor: "pointer",
                      }}
                    />
                  </div>
                </Modal>
              )}
              {showVideoModal && (
                <Modal
                  className="modal fade "
                  // dialogClassName="modal-50w"
                  size="lg"
                  backdrop="static"
                  show={showVideoModal}
                  onHide={() => {
                    setSelectedVideo("");
                    setShowVideoModal(false);
                  }}
                >
                  <div className="modal-header border-0">
                    <button
                      type="button"
                      className="close btn"
                      onClick={() => {
                        setSelectedVideo("");
                        setShowVideoModal(false);
                      }}
                    >
                      <span>×</span>
                    </button>
                  </div>
                  <div className="mx-auto my-5">
                    <video
                      src={selectedVideo}
                      alt=""
                      // loading="lazy"
                      style={{
                        width: "500px",
                        cursor: "pointer",
                      }}
                      controls
                    />
                  </div>
                </Modal>
              )}
              {showDocModal && (
                <DocumentViewer
                  filePath={selectedDoc}
                  open={showDocModal}
                  handleClose={() => {
                    setSelectedDoc("");
                    setShowDocModal(false);
                  }}
                />
              )}
              {/* Minutes of Business */}

              {businessMinutes !== null && role?.role?.id !== 3 && (
                <div className="row row my-2 p-2  border-bx">
                  {!isLoading ? (
                    <div className="row gap-2">
                      {businessMinutes.map((item) => (
                        <div className="col-3 border cursor-pointer p-2 minute-card">
                          <div
                            className="delete-minute"
                            onClick={() => {
                              dispatch(
                                minutesActions.setSelectedMinute(item.id)
                              );
                              dispatch(minutesThunks.deleteMinute(item.id));
                            }}
                          >
                            <i class="fa fa-trash-o" aria-hidden="true"></i>
                          </div>
                          <h4>{item.title}</h4>
                          <button
                            className="btn btn-primary"
                            onClick={() => {
                              setShowMinutesModal(true);

                              dispatch(minutesThunks.fetchMinuteById(item.id));
                            }}
                          >
                            {t("viewDetails")}
                          </button>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div>{t("hloading")}</div>
                  )}
                </div>
              )}

              <Modal
                className="modal fade "
                // dialogClassName="modal-50w"
                size="lg"
                backdrop="static"
                show={showMinutesModal}
                onHide={() => {
                  setShowMinutesModal(false);
                }}
              >
                <div className="modal-header border-0">
                  <button
                    type="button"
                    className="close btn"
                    onClick={() => {
                      setShowMinutesModal(false);
                    }}
                  >
                    <span>×</span>
                  </button>
                </div>
                <div className="m-2">
                  {isLoading ? (
                    <div>{t("hloading")}</div>
                  ) : (
                    <div>
                      <h4>{minute?.title}</h4>
                      <div
                        dangerouslySetInnerHTML={{ __html: minute?.content }}
                        style={{
                          lineHeight: "1.6",
                          fontSize: "16px",
                        }}
                        className="content-with-images"
                      />
                    </div>
                  )}
                </div>
              </Modal>
              {/* review details */}
              {ctxObj?.loggedinprofiletype !== "sellerprofile" &&
                ctxObj?.loggedinprofiletype !== "buyerprofile" && (
                  <div className="my-5">
                    <div className="row border">
                      <h3 className="py-2">
                        {t("businessDetailsReviewTitle")}
                      </h3>
                    </div>

                    <div className="row border">
                      <div
                        className="col-4 border-end"
                        style={{ height: "100%" }}
                      >
                        <div className="border-bottom py-3 text-center">
                          <h6>{t("businessDetailsAverageRating")}</h6>
                          <h1 style={{ color: "#dc3545" }}>
                            {/* {totalReviews === 0 ? 0 : totalRating?.toFixed(1)} 5.0 */}
                            {businessDetails.rating === -1
                              ? 0
                              : businessDetails.rating}
                          </h1>

                          <div style={{ color: "#6c757d" }}>
                            {/* ({fShortenNumber(totalReviews)} {t(totalReviews > 1 ? "reviews" : "review")})( 1 review
                        ) */}
                            ( 1 {t("businessDetailsreview")} )
                          </div>
                        </div>

                        <div className="border-bottom py-3 text-center">
                          {Array.from({ length: businessDetails.rating }).map(
                            (_, index) => {
                              // const match = reviewsSummery.find((v) => v._id === index + 1);
                              return (
                                <ProgressItem
                                  key={index}
                                  star={1 || 0}
                                  // star={match?.count || 0}
                                  name={Number(`${4 - index}`) + 1}
                                  total={1}
                                />
                              );
                            }
                          )}
                        </div>
                      </div>

                      <div className="col-8">
                        <ReviewItem
                          isLoading={false}
                          repr={businessDetails.representative_name}
                          note={businessDetails.rating}
                          review={businessDetails.rate_comment}
                        />
                      </div>
                    </div>
                  </div>
                )}
            </div>
          </div>
        </div>
      ) : null}

      {showAssignModal && (
        <Modal
          className="modal fade "
          size="lg"
          backdrop="static"
          show={showAssignModal}
          onHide={() => setShowAssignModal(false)}
        >
          <div className="" role="document">
            <div className="modal-header">
              <h4 className="modal-title fs-20">
                {t("businessDetailsAssigntitle")}
              </h4>
              <button
                type="button"
                className="close btn"
                onClick={() => {
                  setShowAssignModal(false);
                }}
              >
                <span>×</span>
              </button>
            </div>
            {businessDetails?.assigned_representative_id && (
              <div className="w-75 mx-auto my-5">
                <h5>{t("Assigned Representative")}</h5>
                <table className="table table-striped table-bordered table-hover align-middle">
                  <thead>
                    <tr>
                      <th>{t("name")}</th>
                      <th className="text-center">{t("action")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{businessDetails?.representative_name ?? ""}</td>

                      <td className="text-center">
                        <button
                          className="btn btn-primary btn-sm"
                          onClick={() =>
                            businessReAsignHandler(
                              businessDetails?.assigned_representative_id
                            )
                          }
                        >
                          {t("reAssign")}
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            )}
            {requestedRep && Object.keys(requestedRep).length > 0 && (
              <div className="w-75 mx-auto my-5">
                <h5>{t("requestedRepresentative")}</h5>
                <table className="table table-striped table-bordered table-hover align-middle">
                  <thead>
                    <tr>
                      <th>{t("name")}</th>
                      <th>{t("email")}</th>
                      <th>{t("status")}</th>
                      <th>{t("action")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        {requestedRep?.firstname ?? ""}{" "}
                        {requestedRep?.lastname ?? ""}
                      </td>
                      <td>{requestedRep?.email ?? ""}</td>
                      <td>
                        <div className="d-flex align-items-center gap-2">
                          <button className="btn btn-success btn-sm">
                            {t("requested")}
                          </button>
                        </div>
                      </td>
                      <td>
                        <div className="d-flex align-items-center gap-2">
                          <button
                            className="btn btn-danger btn-sm"
                            onClick={() => cancelRepRequest(requestedRep?.id)}
                          >
                            {t("cancel")}
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            )}
            <div className="w-75 mx-auto my-5">
              <div class="mb-3">
                <label
                  htmlFor="exampleFormControlInput1"
                  className="form-label me-3"
                >
                  {t("hsearchRepre")}
                </label>
                <div className="d-flex">
                  <button
                    className="btn btn-primary "
                    style={{ borderRadius: "5px 0 0 5px" }}
                  >
                    <i class="fa fa-search" aria-hidden="true"></i>
                  </button>
                  <input
                    type="text"
                    id="exampleFormControlInput1"
                    placeholder={t("search")}
                    style={{ borderRadius: "0 5px 5px 0" }}
                    className="input-search form-control px-2"
                    onChange={representativeSearchHandler}
                  />
                </div>
              </div>
              {/* {representativeList?.length !== 0 && (
                <div>
                  {representativeList?.map((item, index) => (
                    <div className="form-check" key={index}>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={item.id === selectedRepresentativeId}
                        onChange={() => setSelectedRepresentativeId(item.id)}
                        id={`flexCheckDefault${index}`}
                      />
                      <label
                        className="form-check-label"
                        for={`flexCheckDefault${index}`}
                      >
                        {item?.firstname ?? ""} {item?.lastname ?? ""}
                      </label>
                    </div>
                  ))}
                </div>
              )} */}

              <table className="table table-striped table-bordered table-hover align-middle">
                <thead>
                  <tr>
                    <th>{t("name")}</th>
                    <th>{t("email")}</th>
                    <th>{t("status")}</th>
                    <th>{t("action")}</th>
                  </tr>
                </thead>
                <tbody>
                  {currentRowsRep?.length > 0 ? (
                    currentRowsRep.map((item, index) => (
                      <tr key={index}>
                        <td>
                          {item?.firstname ?? ""} {item?.lastname ?? ""}
                        </td>
                        <td>{item?.email ?? ""}</td>
                        <td
                          style={{
                            color: item?.isavailable === true ? "green" : "red",
                          }}
                        >
                          {item?.isavailable === true
                            ? t("available")
                            : t("busy")}
                        </td>
                        <td>
                          <button
                            className="btn btn-primary btn-sm"
                            disabled={
                              businessDetails?.assigned_representative_id ||
                              Object.keys(requestedRep).length > 0 ||
                              !item.isavailable
                            }
                            onClick={() => requestRepresentative(item?.id)}
                          >
                            {t("request")}
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={3} className="text-center">
                        {t("noProfessionalRequested") ?? "No data found"}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>

              {/* Pagination Controls */}
              <div className="d-flex justify-content-between align-items-center p-2">
                <span>
                  Page {currentPageRep} of {totalPagesRep}
                </span>
                <div>
                  <button
                    className="btn btn-secondary btn-sm me-2"
                    disabled={currentPageRep === 1}
                    onClick={() => setCurrentPageRep((prev) => prev - 1)}
                  >
                    {t("prev")}
                  </button>
                  <button
                    className="btn btn-secondary btn-sm"
                    disabled={currentPageRep === totalPagesRep}
                    onClick={() => setCurrentPageRep((prev) => prev + 1)}
                  >
                    {t("next")}
                  </button>
                </div>
              </div>
            </div>

            {/* <div className="d-flex justify-content-end mb-2 me-5">
              <button
                onClick={() => {
                  setShowAssignModal(false);
                }}
                type="reset"
                className="btn btn-primary me-4"
              >
                {t("globalDiscardButton")}
              </button>
              <button
                type="submit"
                className="btn btn-primary "
                onClick={businessAsignHandler}
                disabled={selectedRepresentativeId === ""}
              >
                {t("businessDetailsAssigntitle")}
              </button>
            </div> */}
          </div>
        </Modal>
      )}
      {professionalAssignModal && (
        <Modal
          className="modal fade"
          size="lg"
          backdrop="static"
          show={professionalAssignModal}
          onHide={() => setProfessinalAssignModal(false)}
        >
          <div className="table-responsive">
            <div className="modal-header">
              <h4 className="modal-title fs-20">
                {t("businessAssignToProfessionalButton")}
              </h4>
              <button
                type="button"
                className="close btn"
                onClick={() => {
                  setProfessinalAssignModal(false);
                }}
              >
                <span>×</span>
              </button>
            </div>
            <h4>{t("listOfAssignedProfessionals")}</h4>
            <table className="table table-striped table-bordered table-hover align-middle">
              <thead>
                <tr>
                  <th>{t("name")}</th>
                  <th>{t("email")}</th>
                  <th>{t("profession")}</th>
                  <th>{t("status")}</th>
                </tr>
              </thead>
              <tbody>
                {AssignedProfessionalList?.length > 0 ? (
                  AssignedProfessionalList.map((item, index) => (
                    <tr key={index}>
                      <td>{item?.name ?? ""}</td>
                      <td>{item?.email ?? ""}</td>
                      <td>{item?.profession ?? ""}</td>
                      <td>
                        <button
                          className={"btn btn-success btn-sm"}
                          onClick={() =>
                            assignToProfessional(item?.id, item?.profession)
                          }
                          disabled={item?.status === "ASSIGNED"}
                        >
                          <span className="d-flex gap-1 align-items-center">
                            <i
                              class="fa fa-check-circle"
                              aria-hidden="true"
                            ></i>
                            {t("assigned")}
                          </span>
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={4} className="text-center">
                      {t("noProfessionalAssigned") ?? "No data found"}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            <label
              htmlFor="exampleFormControlInput1"
              className="form-label me-3"
            >
              {t("searchProfessional")}
            </label>
            <div className="d-flex mb-4">
              <button
                className="btn btn-primary "
                style={{ borderRadius: "5px 0 0 5px" }}
              >
                <i class="fa fa-search" aria-hidden="true"></i>
              </button>
              <input
                type="text"
                id="exampleFormControlInput1"
                placeholder={t("search")}
                style={{ borderRadius: "0 5px 5px 0" }}
                className="input-search form-control px-2"
                onChange={(e) => setSearchProfessional(e.target.value)}
              />
            </div>

            <h4>{t("listOfRequestedProfessionals")}</h4>
            <table className="table table-striped table-bordered table-hover align-middle">
              <thead>
                <tr>
                  <th>{t("name")}</th>
                  <th>{t("email")}</th>
                  <th>{t("profession")}</th>
                  <th>{t("action")}</th>
                </tr>
              </thead>
              <tbody>
                {currentRows?.length > 0 ? (
                  currentRows.map((item, index) => (
                    <tr key={index}>
                      <td>{item?.name ?? ""}</td>
                      <td>{item?.email ?? ""}</td>
                      <td>{item?.profession ?? ""}</td>
                      <td>
                        <button
                          className={"btn btn-primary btn-sm"}
                          onClick={() =>
                            assignToProfessional(item?.id, item?.profession)
                          }
                          disabled={item?.status === "ASSIGNED"}
                        >
                          {t("assign")}
                          {/* {item?.status === "ASSIGNED" ? (
                            <span className="d-flex gap-1 align-items-center">
                              <i
                                class="fa fa-check-circle"
                                aria-hidden="true"
                              ></i>
                              {t("assigned")}
                            </span>
                          ) : (
                            t("assign")
                          )} */}
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={4} className="text-center">
                      {t("noProfessionalRequested") ?? "No data found"}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            {/* Pagination Controls */}
            <div className="d-flex justify-content-between align-items-center p-2">
              <span>
                Page {currentPage} of {totalPages}
              </span>
              <div>
                <button
                  className="btn btn-secondary btn-sm me-2"
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage((prev) => prev - 1)}
                >
                  Prev
                </button>
                <button
                  className="btn btn-secondary btn-sm"
                  disabled={currentPage === totalPages}
                  onClick={() => setCurrentPage((prev) => prev + 1)}
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </Modal>
      )}

      {createContract?.cond && (
        <AddContractPopup
          show={createContract?.cond}
          data={createContract?.data}
          onHideModal={onHideModal}
        />
      )}
      {/* DealProgress Tracker---------------------  */}
      {/* {dealTracker && role?.role?.id === 1 && (
        <DealProgressTracker
          stages={progress}
          onClose={() => setDealTracker(false)}
          loading={progressLoading}
        />
      )} */}
      {showNoteModal && (
        <Modal
          className="modal fade "
          size="xl"
          backdrop="static"
          show={showNoteModal}
          onHide={() => setShowNoteModal(false)}
        >
          <div className="" role="document">
            <div className="modal-header  border-0">
              <h4 className="modal-title fs-20">{t("addAMinutes")}</h4>
              <button
                type="button"
                className="close btn"
                onClick={() => {
                  setShowNoteModal(false);
                }}
              >
                <span>×</span>
              </button>
            </div>
            <div className="my-3 px-5">
              <div className="form-group">
                <label className="mb-1">
                  <span className="text-danger">*</span>
                  &ensp;
                  <strong>{t("voiceNote_titleLabel")}</strong>
                </label>
                <input
                  type="text"
                  placeholder="title"
                  className="form-control"
                  onChange={(e) => setNoteTitle(e.target.value)}
                />
              </div>
            </div>
            <div className="px-5">
              {isScriptLoaded ? (
                <Editor
                  apiKey="9uyd1owf1vmpx5mb2c4sc3rpxtxloet9yfgnqtfsj093z0cf"
                  tinymceScriptSrc={"/tinymce/tinymce.min.js"}
                  init={{
                    plugins:
                      "mentions anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount checklist mediaembed casechange export formatpainter pageembed permanentpen footnotes advtemplate advtable advcode editimage tableofcontents mergetags powerpaste tinymcespellchecker autocorrect a11ychecker typography inlinecss",
                    toolbar:
                      "undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table mergetags | align lineheight | tinycomments | checklist numlist bullist indent outdent | emoticons charmap | removeformat",

                    height: "400px",
                  }}
                  initialValue={noteContent}
                  onChange={(e) => {
                    setNoteContent(e.target.getContent());
                  }}
                />
              ) : (
                <div>{t("hloadingedit")}</div>
              )}
            </div>
            <div className="d-flex justify-content-end my-2 me-5">
              <button
                disabled={noteContent === "" || noteTitle === ""}
                className="btn btn-primary me-4 px-5"
                onClick={submitNoteHandler}
              >
                {t("saveButton")}
              </button>
            </div>
          </div>
        </Modal>
      )}
      {showVoiceNoteModal && (
        <VoiceNote
          open={showVoiceNoteModal}
          setOpen={setShowVoiceNoteModal}
          businessId={params?.businessId}
          allFiles={allFiles}
          getBusinessDetails={getBusinessDetails}
        />
      )}
    </>
  );
}

export default BusinessDetails;
